// CustomDropdown.tsx
import React, { useContext, useEffect, useRef, useState } from "react";
import { Currency } from "../../lib/interfaces/ICurrencyInterface"; // Adjust the path accordingly
import { MdKeyboardArrowDown } from "react-icons/md";
import { AuthContext } from "../AuthContextComponent";
import useUserLogin from "../../hooks/UserLoginhook";

interface CurrencyDropdownProps {
  label: string;
  options: Currency[];
  isRequired?: boolean;
  onSelect: (value: string) => void;
}

const CurrencyDropdown: React.FC<CurrencyDropdownProps> = ({
  label,
  options,
  isRequired,
  onSelect,
}) => {
  const userInfo = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const { customColor } = useUserLogin();
  const [selected, setSelected] = useState<string | null>(null);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleSelect = (option: Currency) => {
    setSelected(option.code); // Set the currency code as the selected value
    onSelect(option.code); // Pass the currency code to the onSelect handler
    setIsOpen(false);
    setHoveredIndex(null);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div className="relative w-80 md:pl-2 h-full p-2" ref={dropdownRef}>
      <p
        className={`pl-2 pb-1 text-custom-micro ${
          userInfo.userInfo?.theme === "DARK"
            ? "text-custom-dark-theme-text"
            : "text-black"
        }`}
      >
        {label}
      </p>
      <div
        className={`border border-gray-300 rounded-md p-2 cursor-pointer bg-white hover:bg-gray-100 flex items-center justify-between text-custom-petite h-[30px] ${
          isRequired ? `border border-red-600 text-custom-default` : ``
        }`}
        onClick={toggleDropdown}
      >
        {selected || "SELECT"} <MdKeyboardArrowDown />
      </div>
      {isOpen && (
        <div
          className={`absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg`}
        >
          {options.map((option, index) => (
            <div
              key={option.code}
              style={{
                backgroundColor:
                  hoveredIndex === index ? customColor : "transparent",
                transition: "background-color 0.3s",
              }}
              className={`p-2  hover:rounded-md hover:text-white hover:bg-custom-default-hover cursor-pointer text-custom-petite `}
              onClick={() => handleSelect(option)}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              {option.code}
            </div>
          ))}
        </div>
      )}

      <div
        className={`text-custom-micro text-custom-default ${
          isRequired ? "block" : "invisible h-0"
        }`}
      >
        *Required
      </div>
    </div>
  );
};

export default CurrencyDropdown;
